import type { GeoCountries, VideoEncoding } from '@/types/videoTypes'

export const COUNTRIES_DACH = ['de', 'at', 'ch']
export const COUNTRIES_DACHLILU = ['de', 'at', 'ch', 'li', 'lu']

export function toGeoCountries(input: unknown): GeoCountries {
  const s = String(input ?? '')
    .trim()
    .toLowerCase()
  if (s === 'de' || s === 'dach' || s === 'dachlilu' || s === 'world') {
    return s as GeoCountries
  }
  return 'de'
}

export const geoAllowed = (
  videoAllowedForCountry: GeoCountries,
  clientCountryCode?: string,
) => {
  const cc = String(clientCountryCode ?? '')
    .trim()
    .toLowerCase()

  if (!cc || cc.length !== 2 || cc === 'xx') return true

  if (videoAllowedForCountry === 'world') return true
  if (videoAllowedForCountry === 'dachlilu')
    return COUNTRIES_DACHLILU.includes(cc)
  if (videoAllowedForCountry === 'dach') return COUNTRIES_DACH.includes(cc)
  return cc === 'de'
}

export const getVideoEncoding = (
  encodings?: Array<VideoEncoding>,
  format: string = 'progressive',
): VideoEncoding | undefined => {
  if (!encodings) {
    return undefined
  }

  const pin = encodings.find(
    ({ value }) => value['encoding-format'].value === format,
  )

  if (pin) {
    return pin
  }

  return encodings.length > 0 ? encodings[0] : undefined
}

export const getVideoDuration = (encodings?: Array<VideoEncoding>): number => {
  if (!encodings) {
    return 0
  }

  const video = getVideoEncoding(encodings)

  return video ? parseFloat(video?.value?.duration?.value ?? 0) / 1000 : 0
}
